<script>
  export let onRequestClose;
  export let muxVideoId;

  import Modal from './Modal.svelte';
  import PlayerPreview from './PlayerPreview.svelte';
  import { onMount } from 'svelte';


  let player, controlsVisible;
  controlsVisible = true;
  let infoScreen = true;
  let _isControlsActive, tracks;


  const dataSetup = JSON.stringify({
    "fill": true,
    html5: {
      hls: {
        // cause android does not support captions
        overrideNative: true
      }
    }
  });

  function enableTrack() {
    var tracks = player.textTracks();
    console.log("enableTrack()", tracks)
    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];
      console.log(track)
    
      // Find the English captions track and mark it as "showing".
      if (track.language === 'en-US') {
        console.log('found english track to show!')
        track.mode = 'showing';
      }
    }
  }

  onMount(async () => {
    console.log('Player:onMount()')
		videojs(document.querySelector("video")).ready(function(){
      console.log('videojs:ready');
      player = this;

      player.mux({
        debug: false,
        data: {
          env_key: 't1c4nte3u9oba1cs5t9fijqmq',

          // Metadata
          player_name: 'main-player', 
          player_init_time: Date.now()

          // ... and other metadata
        }
      });

      player.on("useractive", () => {
        controlsVisible = true;
      })
      player.on("userinactive", () => {
        controlsVisible = false;
      })      
      const set =  (e) => {
        console.log(e);
        enableTrack();
      };
      //player.on("play", set);
      player.on("canplay", set);
    });

    return () => {
      if (player) {
        console.log('now disposing')
        player.dispose();
        player = null;
      }
    }
  });

  function handlePlayClick() {
    mixpanel.track(
        "Video Play", {muxVideoId}
    );    
    infoScreen = false;
    player.play();
  }

  function handlePlayerClose() {
    mixpanel.track(
        "Video Close", {muxVideoId}
    );
    player.pause();
    infoScreen = true;
  }

  function handleInfoScreenBack() {
    mixpanel.track(
        "Video Back", {muxVideoId}
    );
    onRequestClose();
  }
</script>

<style>
:global(.PlayerModalContainer) {
  display: flex;
  align-items: center;
}

.iossveltefix {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: black;
    z-index: 100;
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: black;
    color: white;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    z-index: 400;
}
</style>

<Modal
  on:requestclose={handlePlayerClose}
  on:requestback={handleInfoScreenBack}
  backVisible={infoScreen}
  closeVisible={controlsVisible && !infoScreen}
  className={"PlayerModalContainer"}
>
  <div class="iossveltefix">
    <video
      id="my-video"
      class="video-js vjs-theme-city" 
      controls
      playsinline
      preload="auto"
      data-setup={dataSetup}
    >
      <source src="https://stream.mux.com/{muxVideoId}.m3u8" type="application/x-mpegURL" />        
    </video>

  </div>
  
  {#if infoScreen}
  <div class="overlay">
    <PlayerPreview playClick={handlePlayClick} />
  </div>
  {/if}
</Modal>